export default "__VITE_PUBLIC_ASSET__92173394__"